export default "__VITE_ASSET__zJyIrY1T__"